import React from 'react';

export const ChevronUp = () => (
    <polyline points='6 15 12 9 18 15' />
);